var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewDealBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 181,
    viewBox: "0 0 281 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.791 75.3748L79.2929 -62.0148C68.3758 -58.617 57.9828 -54.4067 48.2012 -49.3838L113.878 75.301L113.791 75.3748Z",
    fill: "#FF7926"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.29 -63.1229L162.442 75.3748L228.993 -51.0089C219.036 -55.8841 208.381 -59.9467 197.29 -63.1229Z",
    fill: "#FF7926"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.366 72.3464L181.301 -67.0376C170.034 -69.3275 158.331 -70.6571 146.366 -70.9525V72.3464Z",
    fill: "#FF7926"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.865 -70.8047C117.9 -70.2138 106.285 -68.6627 95.1055 -66.1512L129.865 72.3464V-70.8047Z",
    fill: "#FF7926"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4052 99.5294L-25.0708 23.7435C-28.5642 31.13 -31.359 38.8859 -33.4551 46.7895L74.4052 99.5294Z",
    fill: "#FF7926"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3684 111.643L-36.4263 61.4146C-37.2123 67.2499 -37.7363 73.1592 -37.7363 79.2161V82.9833L66.3684 111.569V111.643Z",
    fill: "#FF7926"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.23187 -11.7861C-7.52008 -4.84272 -13.1096 2.54382 -17.9131 10.4474L85.493 89.188L-1.23187 -11.7861Z",
    fill: "#FF7926"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0409 152.491L-37.7363 161.207V179.599L61.0409 152.491Z",
    fill: "#FF7926"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1195 138.604L-37.7363 129.961V147.246L59.1195 138.604Z",
    fill: "#FF7926"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0409 124.717L-37.7363 97.6081V116.001L61.0409 124.717Z",
    fill: "#FF7926"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.191 152.491L318.073 180.707V161.576L215.191 152.491Z",
    fill: "#FF7926"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.826 99.5289L313.267 45.0901C310.996 36.9649 308.114 28.9875 304.359 21.4532L201.826 99.6028V99.5289Z",
    fill: "#FF7926"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6812 80.9891L34.3144 -41.4798C25.4061 -35.866 17.1965 -29.6613 9.68555 -22.7918L98.7685 80.9152L98.6812 80.9891Z",
    fill: "#FF7926"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M217.106 138.604L318.067 147.541V129.592L217.106 138.604Z",
    fill: "#FF7926"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.555 80.9889L268.384 -24.8602C260.611 -31.7297 252.14 -37.8605 242.97 -43.4005L177.555 80.9889Z",
    fill: "#FF7926"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M190.736 89.1143L296.937 8.23168C291.872 0.328085 286.02 -7.13232 279.47 -14.1495L190.736 89.1143Z",
    fill: "#FF7926"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M318.073 96.5001L215.191 124.717L318.073 115.631V96.5001Z",
    fill: "#FF7926"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M318.066 81.8748V79.2156C318.066 72.5678 317.367 65.9937 316.407 59.5674L209.856 111.569L318.066 81.8009V81.8748Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDealBackground);
export default __webpack_public_path__ + "static/media/new-deal-background.423f3c3cb061db719b978a316fcc6dad.svg";
export { ForwardRef as ReactComponent };